import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { i18nInit } from './locales/index.ts';
import CssBaseline from '@mui/material/CssBaseline';
import { ClinicalThemeProvider } from './shared/lib/providers/ClinicalThemeProvider.tsx';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoaderProvider } from './pages/components/LoaderContext.tsx';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from '@auth/AuthProvider.tsx';
import { loginRequest, apiRequest, msalInstance } from './msalConfig.ts';
import { setAuthConfig } from '@auth/authConfig.ts';
import { FontSizeProvider } from '@qler-view/shared_lib/src/shared/lib/providers/FontSizeContext';
i18nInit();
setAuthConfig(msalInstance, apiRequest);
// Initialize React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2, // Retry failed requests twice
      refetchOnWindowFocus: false, // Disable refetch on window focus
    },
  },
});

async function bootstrap() {
  await msalInstance.initialize();

  createRoot(document.getElementById('root')!).render(
    <ClinicalThemeProvider>
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <AuthProvider loginRequest={loginRequest} apiRequest={apiRequest}>
              <QueryClientProvider client={queryClient}>
                <CssBaseline />
                <FontSizeProvider>
                  <LoaderProvider>
                    <App />
                  </LoaderProvider>
                </FontSizeProvider>
              </QueryClientProvider>
            </AuthProvider>
          </BrowserRouter>
        </MsalProvider>
      </StrictMode>
    </ClinicalThemeProvider>
  );
}

bootstrap();
